// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xq5A","location":"Header_location__1BN_E"};